// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import moment from 'moment'
import type { CustomerSalesReport } from './types'
import css from './customerSales.css'
type Props = {
  data: CustomerSalesReport
  handleSelectNote: () => void
}

const DayRow = ({ data, handleSelectNote }: Props) => {
  const { date, salesVolume, salesAmount, target, notes } = data
  return (
    <tr className={css.dayRow}>
      <td>
        {moment(date).format('D.M')} - {moment(date).format('dd')}
      </td>
      <td>{salesVolume}</td>
      <td>{Math.round(salesAmount)}</td>
      <td>{target}</td>
      <td>{salesVolume - target}</td>
      <td>
        <p
          onClick={handleSelectNote({
            date,
            notes,
          })}
          className={css.notes}
        >
          {notes}
        </p>
      </td>
    </tr>
  )
}

export default DayRow
